import { css } from "@emotion/react"

export const carousel = css`
	padding: 1rem;
	max-width: 100%;
	width: 100%;
	overflow-x: auto;
	gap: 24px;
	&::-webkit-scrollbar {
		height: 1rem;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #cccccc;
		border-radius: 2px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}
`
